// OrderInfo.js
import React from "react";
import { Descriptions, Typography, Tag, Table } from "antd";
import { formatDate, formatCurrency } from "../../../lib/utils";

const { Title } = Typography;

const getStatusColor = (estado) => {
  switch (estado?.toLowerCase()) {
    case 'creada':
      return 'blue';
    case 'ingreso parcial':
      return 'orange';
    case 'ingreso total':
      return 'green';
    default:
      return 'default';
  }
};

const OrderInfo = ({ selectedSerial }) => {
  if (!selectedSerial.orden_compra_ingreso) {
    return <p>No hay información de orden de compra disponible</p>;
  }

  const order = selectedSerial.orden_compra_ingreso;

  // Modify columns to use serial's product information
  const columns = [
    {
      title: 'Nombre',
      dataIndex: ['producto', 'nombre'],
      key: 'nombre',
      render: () => selectedSerial.producto?.nombre || 'N/A',
    },
   
    {
      title: 'Valor sin impuestos',
      dataIndex: 'valor_sim',
      key: 'valor_sim',
      render: () => formatCurrency(selectedSerial.producto?.preciosinimp || 0),
    },
    {
      title: 'Impuesto',
      dataIndex: ['producto', 'grupo', 'impuesto'],
      key: 'impuesto',
     
      render: () => selectedSerial.producto?.grupo?.impuesto || 0,
    },
    {
      title: 'Precio final',
      dataIndex: 'precio_uni_final',
      key: 'precio_uni_final',
      render: () => parseFloat(selectedSerial.producto?.preciosinimp + selectedSerial.producto?.grupo?.impuesto)  || 0,
    }
  ];

  // Create a single item array with the serial's product data
  const productData = [{
    id: selectedSerial.id,
    producto: selectedSerial.producto,
    cantidad: 1,
    valor_sim: selectedSerial.producto?.preciosinimp,
    precio_compra: selectedSerial.producto?.precio_compra,
    precio_uni_final: selectedSerial.producto?.precio_final
  }];

  return (
    <>
      <Title level={4}>Información de Orden de Compra</Title>
      <Descriptions bordered column={2}>
        <Descriptions.Item label="ID de Orden">
          {order.id}
        </Descriptions.Item>
        <Descriptions.Item label="Número de Factura">
          {order.numero_factura || "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label="Estado">
          <Tag color={getStatusColor(order.estado?.nombre)}>
            {order.estado?.nombre || "N/A"}
          </Tag>
        </Descriptions.Item>
        <Descriptions.Item label="Proveedor">
          {order.proveedor?.nombre || "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label="Creado por">
          {`${order.user_created?.first_name || ''} ${order.user_created?.last_name || ''}`}
        </Descriptions.Item>
        <Descriptions.Item label="Ingresado por">
          {order.ingresado_por?.first_name || "No ingresado"}
        </Descriptions.Item>
        <Descriptions.Item label="Fecha de creación">
          {formatDate(order.date_created)}
        </Descriptions.Item>
        <Descriptions.Item label="Última actualización">
          {formatDate(order.date_updated)}
        </Descriptions.Item>
      </Descriptions>

      <Title level={5} style={{ marginTop: 16 }}>Información del Producto</Title>
      <Table 
        dataSource={productData} 
        columns={columns}
        rowKey="id"
        pagination={false}
        bordered
      />
    </>
  );
};

export default OrderInfo;